import AgersGatherer from './agers_custom/gatherer';

const games = {
    AgersCustom: [
        AgersGatherer,
    ],
};

export default games;